import Header from 'components/Common/Header';
import { verifyCaptcha, verifyCurrentPassword } from 'fetchers';
import React, { useCallback, useState } from 'react';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [isValid, setIsValid] = useState(false);

  const navigate = useNavigate();

  const ResetButtonComponent = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
        return;
      }

      // const token = await executeRecaptcha('change_password');
      // const response = await verifyCaptcha(token);

      // if (response.message) {
      const verifyPasswordResponse = await verifyCurrentPassword(password);
      if (verifyPasswordResponse.verify) {
        navigate('/mypage/password/setting');
      } else {
        alert('비밀번호가 일치하지 않습니다');
      }
      // }
    }, [executeRecaptcha]);

    return (
      <ResetPasswordConfirmButton
        className='btn btn-primary text-white'
        onClick={handleReCaptchaVerify}
      >
        다음
      </ResetPasswordConfirmButton>
    );
  };

  const handleChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey='6LeHyowfAAAAAM-zFWbIleyq_1hTHaYdvWzjiTgc'
      language='ko'
    >
      <Container>
        <Header title='비밀번호 재설정' />
        <ResetPasswordContainer className='container-fluid d-flex flex-column'>
          <ResetPasswordDescriptionWrapper>
            <ResetPasswordDescriptionIcon className='i-notice-info' />
            <ResetPasswordDescriptionText className='pl-1 text-gray-500'>
              정보를 보호하기 위해 현재 비밀번호를 입력해주세요.
            </ResetPasswordDescriptionText>
          </ResetPasswordDescriptionWrapper>
        </ResetPasswordContainer>
        <ResetPasswordInputWrapper className='container-fluid pt-5'>
          <ResetPasswordInput
            className='form-control pl-2'
            placeholder='현재 비밀번호를 입력해주세요'
            onChange={handleChange}
            type='password'
          />
          <ResetButtonComponent />
        </ResetPasswordInputWrapper>
      </Container>
    </GoogleReCaptchaProvider>
  );
};

const Container = styled.div``;
const ResetPasswordContainer = styled.section``;
const ResetPasswordDescriptionWrapper = styled.article``;
const ResetPasswordDescriptionText = styled.span``;
const ResetPasswordDescriptionIcon = styled.i``;
const ResetPasswordInputWrapper = styled.article``;
const ResetPasswordInput = styled.input``;
const ResetPasswordConfirmButton = styled.button`
  width: 100%;
  height: 64.85px;
  position: absolute;
  left: 0;
  bottom: 0;
  border: 0;
`;

export default ResetPassword;
